export enum MonthEndPermissions {
  View = 'MONTH_END_PROCESS.VIEW',
  Auth = 'MONTH_END_PROCESS.ACTION',
  DbaAuth = 'MONTH_END_PROCESS.DBA.ACTION',
  FinanceAuth = 'MONTH_END_PROCESS.FINANCE.ACTION',
}
